module.exports = [
    "Smart world of child development - children's online system",
    'Postal code: 1439957131',
    'Telegram: @mehroboo',
    'Address: Kargar Shomali St., Tehran, Faculty of Engineering, hamgaraa Technology Research Institute, B3',
    'all rights reserved mehrobo'
]